import React from 'react'

const AllOrder = () => {
  return (
    <div>AllOrder</div>
  )
}

export default AllOrder